import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconTool } from "@tabler/icons-react"
import BaseListItem from "../base"

export interface ToolListItemProps {
  item: Record<string, any>
  className?: string
  /** Custom footer content to replace the default "Added by..." text */
  footer?: React.ReactNode
}

export const ToolListItem: React.FC<ToolListItemProps> = ({ item, className, footer }) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconTool}
    typeLabel="Tool"
    testId="tool-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.USE }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <a href={item.path}>
          <img
            src={item.thumbnailUrl || item.imageUrl}
            alt={item.name}
            className="max-w-[100px] rounded-xl"
          />
        </a>
      )
    }
  />
)

export default ToolListItem
